export const PageHeader = ({ eyebrow, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-10">
    <div>
      <p className="font-mono text-xs uppercase tracking-widest text-emerald-400">{eyebrow}</p>
      <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-2">{title}</h1>
    </div>
    {children}
  </div>
);

export const Panel = ({ className = "", children, ...rest }) => (
  <div className={`rounded-3xl border border-slate-800 bg-slate-900/60 p-6 ${className}`} {...rest}>{children}</div>
);

export const PeriodToggle = ({ value, onChange, options = ["daily", "weekly", "monthly"] }) => (
  <div className="inline-flex rounded-full border border-slate-800 bg-slate-950 p-1" data-testid="period-toggle">
    {options.map((p) => (
      <button key={p} data-testid={`period-${p}-button`} onClick={() => onChange(p)}
        className={`px-4 py-1.5 rounded-full text-sm font-semibold capitalize transition-colors ${
          value === p ? "bg-emerald-500 text-slate-950" : "text-slate-400 hover:text-white"}`}>
        {p}
      </button>
    ))}
  </div>
);

export const PrimaryButton = ({ children, className = "", ...rest }) => (
  <button {...rest}
    className={`inline-flex items-center gap-2 rounded-full bg-emerald-500 text-slate-950 px-5 py-2.5 text-sm font-semibold hover:bg-emerald-400 transition-colors disabled:opacity-50 ${className}`}>
    {children}
  </button>
);

export const fmtTime = (iso) => {
  const d = new Date(iso.endsWith("Z") || iso.includes("+") ? iso : `${iso}Z`);
  return d.toLocaleString();
};
